import { DateTime } from "luxon";

export const getAutoSelectWeek = (startDate: string): number => {
  const start = DateTime.fromISO(startDate).startOf("day");
  const today = DateTime.now().startOf("day");

  if (today < start) return 0;

  const weeksDiff = today.diff(start, "weeks").weeks;

  return Math.floor(weeksDiff) + 1;
};
